var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-141.484375 0-256 114.496094-256 256 0 141.484375 114.496094 256 256 256 141.484375 0 256-114.496094 256-256 0-141.484375-114.496094-256-256-256zm0 472c-119.378906 0-216-96.605469-216-216 0-119.378906 96.605469-216 216-216 119.378906 0 216 96.605469 216 216 0 119.378906-96.605469 216-216 216zm74.601562-277.949219c-1.992187-5.972656-6.679687-10.660156-12.652343-12.652343l-166.875-55.625c-15.59375-5.199219-30.507813 9.675781-25.300781 25.300781l55.625 166.875c1.992187 5.972656 6.679687 10.660156 12.652343 12.652343l166.875 55.625c15.601563 5.199219 30.503907-9.679687 25.300781-25.300781zm-114.414062 101.761719-39.816406-119.441406 119.445312 39.8125 39.8125 119.445312zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#09D3AC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.e8c9adda2a0a1dc665e9563172afa411.svg";
export { ForwardRef as ReactComponent };